"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.shouldCancelAutoPlayOnHover = exports.shouldCancelAutoPlayOnAction = exports.getItemIndexForDotNavigation = exports.checkIsTheLastDotIndex = exports.getDotsNavigationLength = exports.hasDotForEachSlide = exports.isStrategy = exports.shouldDisableButtons = exports.shouldDisableDots = exports.shouldDisableControls = void 0;
var types_1 = require("../types");
function shouldDisableControls(t, o) {
  var t = (t || {}).controlsStrategy,
    o = o || {},
    e = o.itemsInSlide,
    s = o.itemsCount,
    o = o.autoWidth;
  if ((0, exports.isStrategy)(t, types_1.ControlsStrategy.RESPONSIVE)) return !o && e === s;
}
function shouldDisableDots(t, o) {
  return t.disableDotsControls || shouldDisableControls(t, o);
}
function shouldDisableButtons(t, o) {
  return t.disableButtonsControls || !t.infinite && shouldDisableControls(t, o);
}
exports.shouldDisableControls = shouldDisableControls, exports.shouldDisableDots = shouldDisableDots, exports.shouldDisableButtons = shouldDisableButtons;
var isStrategy = function isStrategy(t, o) {
    return void 0 === t && (t = ""), void 0 === o && (o = ""), Boolean(t && t.includes(o));
  },
  hasDotForEachSlide = (exports.isStrategy = isStrategy, function (t, o) {
    return t || (0, exports.isStrategy)(o, types_1.ControlsStrategy.ALTERNATE);
  }),
  getDotsNavigationLength = (exports.hasDotForEachSlide = hasDotForEachSlide, function (t, o, e) {
    return void 0 === t && (t = 0), void 0 === o && (o = 1), (e = void 0 !== e && e) ? t : 0 !== Number(o) && Math.ceil(t / o) || 0;
  }),
  checkIsTheLastDotIndex = (exports.getDotsNavigationLength = getDotsNavigationLength, function (t, o, e) {
    return !o && t === e - 1;
  }),
  getItemIndexForDotNavigation = (exports.checkIsTheLastDotIndex = checkIsTheLastDotIndex, function (t, o, e, s) {
    return (o ? e - s : t * s) || 0;
  }),
  shouldCancelAutoPlayOnAction = (exports.getItemIndexForDotNavigation = getItemIndexForDotNavigation, function (t) {
    return (t = void 0 === t ? "" : t) === types_1.AutoPlayStrategy.ACTION || t === types_1.AutoPlayStrategy.ALL;
  }),
  shouldCancelAutoPlayOnHover = (exports.shouldCancelAutoPlayOnAction = shouldCancelAutoPlayOnAction, function (t) {
    return (t = void 0 === t ? "" : t) === types_1.AutoPlayStrategy.DEFAULT || t === types_1.AutoPlayStrategy.ALL;
  });
exports.shouldCancelAutoPlayOnHover = shouldCancelAutoPlayOnHover;